export default __webpack_public_path__ + "static/28-20448eae8af65d815a0b8858102696ab.png";